import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'emptyStringAsHyphen',
	standalone: true
})
export class EmptyStringAsHyphenPipe implements PipeTransform {
	transform(value: string | null | undefined, ...args: unknown[]): string {
		return value ? value : '-';
	}
}
